const style = (theme) => {
  const output = {
    root: {
      minHeight: '100vh',
      color: theme.colors[1],
      background: theme.colors[3],
      '& .Hero__root': {
        color: `${theme.colors[1]} !important`,
      },
    },
    wrapper: {
      extend: theme.wrapper,
    },
    intro: {
      paddingTop: 180,
      paddingBottom: 180,
    },
  }

  output[theme.mediaInverse.md] = {
  }

  output[theme.mediaInverse.sm] = {
    intro: {
      paddingTop: 50,
      paddingBottom: 50,
    },
  }

  return output
}

export default style
